import React from "react"
import { storyblokEditable } from "@storyblok/react"

import Markdown from "react-markdown"
import { getImage } from "gatsby-plugin-image"
import { useStaticQuery, graphql } from "gatsby"

import { Testimonial } from "gatsby-theme-gba"

const TestimonialEditable = ({ blok }) => {
  const { file, allFile } = useStaticQuery(graphql`
    query TestimonialExampleQuery {
      file(relativePath: { eq: "testimonial.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      allFile(filter: { id: { regex: "/(?:.*)testimonial/" } }) {
        edges {
          node {
            id
            name
            childImageSharp {
              gatsbyImageData(
                width: 791
                quality: 80
                breakpoints: [432, 791]
                layout: CONSTRAINED
              )
            }
          }
        }
      }
    }
  `)

  const filteredFiles = allFile.edges.filter(function (projectFile) {
    if (!blok.image || !projectFile.node.id.includes(blok.image.substring(1))) {
      return false // skip
    }

    return true
  })

  const imageFile = filteredFiles[0]
    ? getImage(filteredFiles[0].node)
    : blok.image

  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <Testimonial
        image={imageFile || file.childImageSharp.gatsbyImageData}
        imageAlt={blok.imageAlt}
        name={blok.name}
      >
        <Markdown>{blok.title}</Markdown>
      </Testimonial>
    </div>
  )
}

export default TestimonialEditable
